module.exports = __webpack_public_path__ + "media/images/costumes/top/dress/thumbnail-3-8010268607d7dcd06c55822cfa43c851.jpg";